export enum TestNotificationId {
  POSTER_INITIALIZED = 'POSTER_INITIALIZED',
}
export const addElementToNotifyTest = (testNotification: TestNotificationId): void => {
  const a = document.createElement('a');
  a.setAttribute('id', testNotification);
  document.body.appendChild(a);
};
